import { useMediaQuery } from '@react-hookz/web';

import { Bar, Container } from './styles';

const SIXTY_SIX_PERCENT = 0.666;
const NINETY_PERCENT = 0.9;

export interface ProgressBarProps {
  className?: string;
  currentStep: number;
  totalSteps: number;
  fillPercent?: number | string;
  isHiddenOnDesktop?: boolean;
  hasLargeBorderRadius?: boolean;
  size?: 'small' | 'large';
}

export const HorizontalProgressBar = ({
  className,
  currentStep,
  totalSteps,
  fillPercent,
  isHiddenOnDesktop = true,
  hasLargeBorderRadius,
  size = 'small',
}: ProgressBarProps) => {
  const md = useMediaQuery('(min-width: 768px)');
  const isHidden = md && isHiddenOnDesktop;

  let fill: number | string = (100 * currentStep) / totalSteps;
  if (typeof fill !== 'number') {
    fill = 0;
  }

  if (currentStep === totalSteps) {
    fill *= totalSteps === 1 ? SIXTY_SIX_PERCENT : NINETY_PERCENT;
  }

  if (fillPercent) {
    fill = fillPercent;
  }

  return (
    <Container className={className} size={size} isHidden={isHidden}>
      <Bar fill={fill} data-testid="bar" hasLargeBorderRadius={hasLargeBorderRadius} />
    </Container>
  );
};
